import React from "react";
import { useSearchParams } from "react-router-dom";
import { ActionBus } from "../models/ActionBus";

const ProductDetailContext = React.createContext({
	modalProps: {
		item: '',
		key: false,
		fullscreen: true,
		identifier: undefined,
		api_page_endpoint: null,
		proposalitem: null,
		bookmarkitem: null,
		item_attr_endpoint: null,
		onClose: null,
	},
	actionBus: null,
	setModalProps: () => { },
});

export const useProductDetailContext = () => {
	const context = React.useContext(ProductDetailContext);
	if (!context) {
		throw new Error(
			"useProductDetailContext must be used within a ProductDetailContextProvider"
		);
	}
	return context;
};

export const ProductDetailContextProvider = ({ children }) => {
	const [modalProps, setModalProps] = React.useState(undefined);
	const [searchParams] = useSearchParams();
	const [actionBus, setActionBus] = React.useState(new ActionBus());

	(!modalProps || !Object.keys(modalProps)) &&
		setModalProps({
			item: searchParams.get('item'),
			fullscreen: true,
			api_page_endpoint: undefined,
			identifier: searchParams.get('item') ? 'id' : undefined,
			proposalitem: undefined,
			bookmarkitem: undefined,
			item_attr_endpoint: undefined,
			onClose: undefined,
		});

	const value = {
		modalProps,
		setModalProps,
		actionBus,
	};

	return (
		<ProductDetailContext.Provider
			value={value}
			displayName="Product Detail Context"
		>
			{children}
		</ProductDetailContext.Provider>
	);
};
